// @ts-check

import USER from 'containers/pages/profile/ts/profileEditorEnum';

/**
 * @typedef {Object} PhonePayload
 * @property {string} [USER.PhoneWork]
 * @property {string} [USER.PhoneWorkDialCode]
 * @property {string} [USER.PhoneWorkCountryCode]
 * @property {string} [USER.PhoneWorkExt]
 * @property {string} [USER.PhoneMobile]
 * @property {string} [USER.PhoneMobileDialCode]
 * @property {string} [USER.PhoneMobileCountryCode]
 * @property {string} [USER.PhoneMobileExt]
 * @property {string} [USER.PhoneOther]
 * @property {string} [USER.PhoneOtherDialCode]
 * @property {string} [USER.PhoneOtherCountryCode]
 * @property {string} [USER.PhoneOtherExt]
 */

/**
 * @function convertPhone
 * @param {string} name
 * @param {string} dialCode
 * @param {string} countryCode
 * @param {string} value
 * @returns {PhonePayload|null}
 */
function convertPhone(name, dialCode, countryCode, value) {
	const splitedValue = value.split(' ');

	if ([USER.PHONE_WORK, USER.PHONE_MOBILE, USER.PHONE_OTHER].includes(name)) {
		const payload = {
			[name]: splitedValue[1] === undefined ? '' : splitedValue[1],
			[`${name}DialCode`]: dialCode,
			[`${name}CountryCode`]: countryCode,
			[`${name}Ext`]: splitedValue.length > 2 ? splitedValue[2].split('-')[1] : '',
		};
		return payload;
	}

	return null;
}

export default convertPhone;
